/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback, useEffect, useRef, useState } from "react";

export function useHScroll(step = 320, deps: any[] = []) {
  const ref = useRef<HTMLDivElement>(null);
  const [canLeft, setCanLeft] = useState(false);
  const [canRight, setCanRight] = useState(false);

  const update = useCallback(() => {
    const el = ref.current;
    if (!el) return;
    const { scrollLeft, clientWidth, scrollWidth } = el;
    setCanLeft(scrollLeft > 0);
    setCanRight(scrollLeft + clientWidth < scrollWidth - 1);
  }, []);

  const scrollByDir = useCallback((dir: 1 | -1) => {
    const el = ref.current;
    if (!el) return;
    const page = Math.max(step, Math.floor(el.clientWidth * 0.9));
    el.scrollBy({ left: dir * page, behavior: "smooth" });
  }, [step]);

  const onWheel = useCallback((e: React.WheelEvent<HTMLDivElement>) => {
    const el = ref.current;
    if (!el) return;
    if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) {
      el.scrollBy({ left: e.deltaY, behavior: "auto" });
    }
  }, []);

  useEffect(() => {
    update();
    const el = ref.current;
    if (!el) return;

    const onScroll = () => update();
    el.addEventListener("scroll", onScroll, { passive: true });

    const ro = new ResizeObserver(update);
    ro.observe(el);

    const onWinResize = () => update();
    window.addEventListener("resize", onWinResize);

    return () => {
      el.removeEventListener("scroll", onScroll);
      ro.disconnect();
      window.removeEventListener("resize", onWinResize);
    };
    // Re-evaluate when the caller says content length changed
  }, [update, ...deps]);

  return {
    ref,
    canLeft,
    canRight,
    scrollLeft: () => scrollByDir(-1),
    scrollRight: () => scrollByDir(1),
    onWheel,
    update,
  };
}

export function chunk<T>(arr: T[], size = 3): T[][] {
  const out: T[][] = [];
  for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
  return out;
}